<template>
    <div class="DriverCreatePage">
        <DashboardSectionHeader title="Add Driver">
            <Button to="/company/drivers" class="link primary">Cancel</Button>
            <Button class="primary" @click="handleCreate" :disabled="submitPending">Create</Button>
        </DashboardSectionHeader>

        <p class="errorMessage" v-if="submitError">{{ submitError }}</p>

        <DriverForm
            ref="driverForm"
            v-bind.sync="driver"
            :di_type.sync="driver.driverInfo.type"
            :di_employeeCode.sync="driver.driverInfo.employeeCode"
            :di_driverLicense.sync="driver.driverInfo.driverLicense"
            :di_rate.sync="driver.driverInfo.rate"
            :di_hiredAt.sync="driver.driverInfo.hiredAt"
            :di_medicalExpireAt.sync="driver.driverInfo.medicalExpireAt"
        />

        <p class="errorMessage" v-if="submitError">{{ submitError }}</p>

        <DashboardSectionHeader>
            <Button to="/company/drivers" class="link primary">Cancel</Button>
            <Button class="primary" @click="handleCreate" :disabled="submitPending">Create</Button>
        </DashboardSectionHeader>
    </div>
</template>

<script>
import * as api from '@/api';
import DashboardSectionHeader from '@/components/DashboardSectionHeader';
import DashboardEditSection from '@/components/DashboardEditSection';
import DriverForm from './components/DriverForm';

export default {
    name: 'DriverCreatePage',

    components: {
        DashboardSectionHeader,
        DashboardEditSection,
        DriverForm,
    },

    data: () => ({
        driver: {
            email: null,
            username: null,
            password: null,
            firstName: null,
            lastName: null,
            phone: null,
            address: null,
            city: null,
            state: null,
            zip: null,
            sendSetupEmail: false,
            driverInfo: {
                type: 'employee',
                employeeCode: null,
                driverLicense: null,
                rate: null,
                hiredAt: null,
                medicalExpireAt: null,
            },
        },

        submitPending: false,
        submitError: null,
    }),

    methods: {
        async handleCreate() {
            if (!this.$refs.driverForm.validate()) {
                return;
            }

            const driver = { ...this.driver };
            driver.email = driver.email?.trim() || null;
            driver.username = driver.username?.trim() || null;
            driver.company = this.$store.state.company.id;

            if (driver.sendSetupEmail) {
                driver.password = null;
            }

            this.submitPending = true;
            this.submitError = null;
            const res = await api.createDriver(driver);
            this.submitPending = false;

            if (res.error) {
                // TODO: send better errors to the client from the back-end (requires refactoring)
                if (res.error.message.startsWith('duplicate key value violates unique constraint')) {
                    this.submitError = 'Email/Username is already taken';
                } else {
                    this.submitError = res.error.message;
                }

                return this.$awn.alert('Failed to create driver');
            }

            this.submitPending = false;
            this.submitError = null;

            this.$router.push(`/company/drivers`);
        },
    },
}
</script>


<style lang="scss">
@import 'globals.scss';

.DriverCreatePage {
    .errorMessage {
        margin: 1rem 0;
        color: $red-color;
        text-align: right;
    }
}
</style>
